import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SendShippingEmailRequest } from '../../domain/entities/shipping-accounting.entity';
import { ShippingAccountingRepository } from '../../domain/interfaces/shipping-accounting-repository.interface';
import { ShippingAccountingList } from '../../domain/models/shipping-accounting-list.model';
import { ShippingAccountingMapper } from '../mappers/shipping-accounting.mapper';
import { InvoiceApiService } from '../services/invoice-api.service';

@Injectable()
export class HttpShippingAccountingRepository implements ShippingAccountingRepository {
  constructor(
    private readonly api: InvoiceApiService,
    private readonly mapper: ShippingAccountingMapper
  ) {}

  getList(query: string): Observable<ShippingAccountingList> {
    return this.api.getShippingAccounting(query).pipe(
      map((response) => ({
        items: response['hydra:member'].map((dto) => this.mapper.fromDto(dto)),
        total: response['hydra:totalItems'],
      }))
    );
  }

  sendEmail(request: SendShippingEmailRequest): Observable<void> {
    return this.api.sendShippingEmail(this.mapper.toSendEmailDto(request));
  }

  downloadCsv(professionalId: string, startDate: string, endDate: string): Observable<Blob> {
    return this.api.downloadShippingCsv(professionalId, startDate, endDate);
  }
}
